import { render, staticRenderFns } from "./AttendanceMail.vue?vue&type=template&id=70b41113&scoped=true"
import script from "./AttendanceMail.vue?vue&type=script&lang=js"
export * from "./AttendanceMail.vue?vue&type=script&lang=js"
import style0 from "./AttendanceMail.vue?vue&type=style&index=0&id=70b41113&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b41113",
  null
  
)

export default component.exports
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QChip,QTooltip,QBtn,QFile,QScrollArea,QList,QRadio,QInnerLoading,QSpinnerIos,QDialog,QCard,QCardSection,QCardActions});
